document.addEventListener('DOMContentLoaded', function(){  
  //Consts
  const b = $('body'),
        s = $('.slider'),
        isTouchDevice = () => {
          return (('ontouchstart' in window) ||
                  (navigator.maxTouchPoints > 0) ||
                  (navigator.msMaxTouchPoints > 0));
        };
  
  //Functions
  function height(){
    document.documentElement.style.cssText = `
      --h:  ${window.innerHeight}px;
      --hs: ${window.innerHeight - $('header').outerHeight(true)}px;
    `;
  }
  height();
  function pressHeight(){
    var t = $('.press-infos-extra.active');
    if(t.length){
      t.each(function(){
        $(this).height($(this).find('> div').outerHeight(true))      
      });  
    }
  }
  var path, push, prev, current;
  function updatePath(){
    if(path.indexOf(push) == -1){
      window.history.pushState({}, 'Filters Active', path+current);
    }else{
      if(path.indexOf(current) == -1){
        window.history.pushState({}, 'Filters Active', path.replace(prev, current));
      }else{
        window.history.pushState({}, 'Filters Active', path.replace(current, ''));
      }
    }
    window.scrollTo(0,0);
  }
  function activeReset(){
   	if($('.filter.active').length || $('.sort.active').length){
      $('#filters-clear').addClass('visible')         
    }else{
      $('#filters-clear').removeClass('visible') 
    } 
  }
  function resetFilters(){
    if($('#filters-trigger').hasClass('active')){
      $('#filters-trigger').removeClass('active').next().removeClass('active').slideUp('medium', 'easeInOutQuint', function(){
        $('.filter-trigger').removeClass('active').next().removeClass('active').hide()      
      })
    }
  }
  function sort(t){
    $(t).addClass('active');
    $('.filter-target').sort(function(a, b){
      if($(t).data('filter') == 'high'){
        return ($(b).data('num')) > ($(a).data('num')) ? 1 : -1; 
      }else{
        return ($(b).data('num')) < ($(a).data('num')) ? 1 : -1;    
      }
    }).prependTo('#products');    
  }
  function nextSlide(){
    if(s.is('#carousel')){
      var speed = 'medium';
    }else{
      var speed = 0;      
    }
    if(!s.hasClass('transition')){
      s.addClass('transition').find('.slider-tracker').animate({
        'left': '-100%'
      }, speed, 'easeInOutQuint', function(){        
        s.find('.slide:first-child').parent().append(s.find('.slide:first-child'));  
        s.find('.slider-tracker').css('left', '0');
        s.removeClass('transition'); 
        if($('.slide:not(:first-child) video').length){
          $('.slide:not(:first-child) video')[0].pause();
        }
      });
      if($('.slide:first-child video').length){
        $('.slide:first-child video')[0].play();
      }      
    }
  }
  function prevSlide(){
    if(s.is('#carousel')){
      var speed = 'medium';
    }else{
      var speed = 0;      
    }
    if(!s.hasClass('transition')){ 
      s.find('.slide:last-child').parent().prepend(s.find('.slide:last-child'));
      s.addClass('transition').find('.slider-tracker').css('left', '-100%').animate({
        'left': '0'
      }, speed, 'easeInOutQuint', function(){          
        s.removeClass('transition');        
        if($('.slide:not(:first-child) video').length){
          $('.slide:not(:first-child) video')[0].pause();
        }
      });        
      if($('.slide:first-child video').length){
        $('.slide:first-child video')[0].play();
      }
    }
  }
  var autoplay,
      speed = s.data('timer');
  function autoPlay(){
    if(s.length && s.hasClass('autoplay')){
      autoplay = setInterval(function(){
        nextSlide();
      }, speed);     
    }
  }
  autoPlay()
  function stopAutoplay(){
    if(s.length && s.hasClass('autoplay')){
      clearInterval(autoplay);
    }   	 
  }
  function checkKey(e){
    e = e || window.event;
    if(e.keyCode == '37' && s.length){
      prevSlide()  
      stopAutoplay()
    }else if(e.keyCode == '39' && s.length){
      nextSlide()  
      stopAutoplay()      
    }
  }
  
  //Device detection
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) ||
     isTouchDevice() == true){
    //If device
    b.addClass('mobile');    
    //Pseudoclass :active on devices
    document.addEventListener('touchstart', function(){}, {passive: true});
    //Resize Functions
    window.addEventListener('orientationchange', function(){
      setTimeout(function(){
        height()
        pressHeight()
      }, 50);
    });    
    //Slider
    if(s.length){
      let tsX = 0,
          teX = 0;
      const s = document.getElementsByClassName('slider')[0];
      s.addEventListener('touchstart', function(event){
        tsX = event.changedTouches[0].screenX;
      }, false);
      s.addEventListener('touchend', function(event){
        teX = event.changedTouches[0].screenX;  
        stopAutoplay()
        if(teX <= tsX && (tsX - teX > 50)){
          nextSlide()
        }
        if(teX >= tsX && (teX - tsX > 50)){
          prevSlide()
        }
      }, false);
    }
  }else{
    //if Desktop
    b.addClass('desktop');
    //Resize Functions
    window.onresize = function(){
      height()
      pressHeight()
    }
    //Slider
    document.onkeydown = checkKey;
  }
  
  //Replace &nbsp;
  if($('.clear').length){
    $('.clear').html(function(i, html){
      return html.replace(/&nbsp;/g, ' ');
    });
    $('.clear div').each(function(){
      $(this).filter(function(){
        return $(this).text().trim().length == 0;
      }).remove();
    });
  }
  
  //Loader
  setTimeout(function(){
    $('#loader').fadeOut(function(){
      $(this).remove();
    });
  }, 200); 
  
  //PopUp  
  var pop = $('#popup');
  if(pop.length){
    if(sessionStorage.getItem('pop-up') != 'true'){
      setTimeout(function(){
        pop.fadeIn();
      }, pop.data('timer')*1000);
    }else{
      pop.remove();      
    }
    pop.find('span').click(function(){
      pop.fadeOut(function(){
        pop.remove();
        sessionStorage.setItem('pop-up', true);
      });
    });
  }  
  
  //Menu
  var m = $('#menu-trigger'),
      M = $('menu');
  m.click(function(){  	
    if(M.hasClass('open')){
      m.removeClass('open').find('span').text('MENU');
      M.slideUp('medium', 'easeOutQuint', function(){        
        autoPlay()
        $('html').removeClass('pop-up-open')
        M.removeClass('open')     
      });
    }else{
      m.addClass('open').find('span').text('CLOSE');
      stopAutoplay()
      M.slideDown('medium', 'easeOutQuint', function(){
        $('html').addClass('pop-up-open')
        M.addClass('open')     
      });
    }  
  });
  
  //Subsections
  $('.links-trigger').click(function(e){
    e.preventDefault()
    var t = $(this),
        p = t.next('div');
    if(p.length){
      if(window.innerWidth > 600){
        if(t.parents('menu').length){
          $('menu .links-trigger').not(t).removeClass('link-active');
        }        
        $('.links--wrapper:visible').hide()
        if(t.hasClass('link-active')){
          t.removeClass('link-active') 
          p.hide()
        }else{
          t.addClass('link-active')  
          p.show()       
        }        
      }else{
        if($('menu .links--wrapper').not(p).is(':visible')){  
          $('menu .links-trigger').not(t).removeClass('link-active');
          t.addClass('link-active');
          $('menu .links--wrapper:visible').slideUp('medium', 'easeInOutQuint', function(){
            p.slideDown('medium', 'easeInOutQuint');
          });
        }else{
          t.toggleClass('link-active');
          p.slideToggle('medium', 'easeInOutQuint');  
        }
      }
    }
  });
  
  //Filters triggers
  if($('#filters-wrapper').length){
    $('header').append($('#filters-wrapper'))
  }
  $('#filters-wrapper').click(function(e){
    e.stopPropagation()
  });
  $('#filters-trigger').click(function(){
    if(!$('#filters-trigger').hasClass('active')){
      $('#filters-trigger').addClass('active').next().slideDown('medium', 'easeInOutQuint')
    }else{
      resetFilters()    
    }
  });
  $('.filter-trigger').click(function(){
    var t = $(this),
        n = t.next();
    if($('.filters--wrapper').not(n).hasClass('active')){
      $('.filter-trigger').removeClass('active');
      t.addClass('active')
      $('.filters--wrapper.active').slideUp('medium', 'easeInOutQuint', function(){
        $(this).removeClass('active');
        n.slideDown('medium', 'easeInOutQuint').addClass('active');
      })
    }else{
      t.toggleClass('active');
      n.slideToggle('medium', 'easeInOutQuint').toggleClass('active');      
    }     
  });
  
    function copyToClipboard(text) {
      var sampleTextarea = document.createElement("textarea");
      document.body.appendChild(sampleTextarea);
      sampleTextarea.value = text; //save main text in it
      sampleTextarea.select(); //select textarea contenrs
      document.execCommand("copy");
      document.body.removeChild(sampleTextarea);
  	}

    function myFunction(){
        var copyText = document.getElementById("message");
        copyToClipboard(copyText.dataset.value);
    }
  
  //Emails
  $('.email').click(function(){
    var t = $(this),
        v = t.data('email');
    if(!$('#message').length){
      t.addClass('email-active');
      $('<div id="message" data-value="'+v+'">Email copied to clipboard</div>').appendTo('body');
      $('#message').fadeIn().addClass('visible');
      myFunction();
      setTimeout(function(){
        $('#message').fadeOut(function(){
          $(this).remove();
        });
      }, 2000);  
      t.text(v)
    }
  });
  
  //Filters
  $('.filter').each(function(){
    var t = $(this),
        k = t.data('filter');
    
    t.click(function(){
      
      //Push filters to url
      path = window.location.href
      push = '?filter='
      prev = push+$('#wrapper').attr('class')
      current = '?filter='+k;      
      updatePath()
      
      $('#wrapper').removeClass().addClass(k)

      $('.filter-target').show();
      if(t.hasClass('active')){
        t.removeClass('active');      
      }else{
        t.addClass('active');
        $('.filter').not(t).removeClass('active');
        $('.filter-target:not(.'+k+')').hide();        
      }
      
      activeReset()
      
    });
  
    //Push Url to active filters on load
    path = window.location.href;
    if(path.indexOf(k) > -1){
      t.addClass('active');
      $('.filter-target:not(.'+k+')').hide();
      activeReset()
    }
  });
  
  //Sort 
  $('.sort').each(function(){
    var t = $(this),
        k = t.data('filter');
    
    t.click(function(){
      
      //Push filters to url
      path = window.location.href
      push = '?sort='
      prev = push+$('.sort').not(t).data('filter')
      current = '?sort='+k;      
      updatePath()
      
      $('.sort').not(t).removeClass('active');
      
      if(t.hasClass('active')){        
        t.removeClass('active');
        $('.filter-target').sort(function(a, b){
          return ($(b).data('pos')) < ($(a).data('pos')) ? 1 : -1;         
        }).prependTo('#products');
      }else{ 
        sort(t)            
      }
      
      activeReset()

  	});
    
    //Push Url to active filters on load
    path = window.location.href;
    if(path.indexOf(k) > -1){
      sort(t)
      activeReset()
    }
  
  });
  
  //Clear Filters
  $('#filters-clear').click(function(){
    $(this).removeClass('visible')
    /*if($('.filter-trigger.active').length){  
      $('.filter-trigger').removeClass('active').next().slideUp('medium', 'easeInOutQuint');
    }   */
    resetFilters()
    if($('.filter.active').length){  
      $('.filter').removeClass('active');    
      $('.filter-target').show();
    }
    if($('.sort.active').length){      
      $('.sort').removeClass('active');      
      $('.filter-target').sort(function(a, b){
        return ($(b).data('pos')) < ($(a).data('pos')) ? 1 : -1;         
      }).prependTo('#products'); 
    }
    path = window.location.href;    
    window.history.pushState({}, 'Filters Active', path.replace(window.location.search, ''));
  });
  
  //Switch Info
  if(sessionStorage.getItem('view-info') === 'true'){
    b.addClass('view-info');
    $('#switch-info input').attr('checked', 'true');
    $('.project-infos').show()
  }
  $('#switch-info .switch-slider').click(function(){
    var v = 'view-info',
        w = window.innerWidth,
        t = $('#switch-info');
    
    //window.scrollTo(0,0);
    
    if(b.hasClass(v)){
    	var a = 'false';  
    }else{
    	var a = 'true';    
    }
    if(w > 600 && w < 1681){
      t.css('pointer-events', 'none');
      setTimeout(function(){
        t.css('pointer-events', 'all');
      }, 500);
    }    
    if(w < 835){
      $('.project-infos').slideToggle('fast', 'easeInOutQuint');          
    }else{
      $('.project-infos').toggle()
    }
    b.toggleClass(v);
    sessionStorage.setItem(v, a);
  });
  
  //Switch View
  if(sessionStorage.getItem('view-single') === 'true' && !b.hasClass('template-product')){
    b.addClass('view-single');
    $('#switch-view input').attr('checked', 'true');
    $('.switch-text').text('Grid');
  }
  $('#switch-view .switch-slider').click(function(){
    var v = 'view-single',
        t = $('#switch-view').next();
    
    //window.scrollTo(0,0);
    
    if(b.hasClass(v)){
    	var a = 'false';  
    }else{
    	var a = 'true';    
    }
    t.text(t.text() == 'Single' ? 'Grid' : 'Single'); 
    /*$('.module-projects').fadeOut('fast', function(){
      b.toggleClass(v);
      sessionStorage.setItem(v, a);
      $('.module-projects').fadeIn('fast')      
    })*/
    b.toggleClass(v);
    sessionStorage.setItem(v, a);
  });
  
  //Exhibit Mode
  $('#switch-exhibit .switch-slider').click(function(){
    b.toggleClass('exhibit-active');
  });
  
  //Slider
  $('#next, .next').click(function(){
   	nextSlide();
    stopAutoplay()
  });
  $('#prev, .prev').click(function(){
    prevSlide();
    stopAutoplay()
  });
  
  //View More
  $('#view-more').click(function () {
    $('html, body').animate({
        scrollTop: $(document).height()
    }, 'medium', 'easeInQuint');
    return false;
  });
  
  //Subsections
  $('.content-wrapper .trigger').click(function(){
    var t = $(this),
        p = t.next();
    if(p.length){
      if($('.content-wrapper .trigger').next().not(p).is(':visible')){        
        $('.content-wrapper .trigger + *:visible').slideUp('medium', 'easeInOutQuint', function(){
          $('.content-wrapper .trigger').removeClass('link-active')
          p.slideDown('medium', 'easeInOutQuint');
        });
      }else{
        p.slideToggle('medium', 'easeInOutQuint');  
      }      
    }
  });
  
  //Press
  $('.link-read-more').click(function(e){
    e.stopPropagation()
  });
  $('.press').click(function(ph, h){
    var t = $(this),
        tp = t.find('.press-infos').outerHeight(true),
        tn = t.find('.press-infos-extra'),
        nh = tn.find('> div').outerHeight(true);
    if(window.innerWidth > 834){
      ph = tp
    }else{
      ph = 0
    }
    if(tn.hasClass('active')){
      h = ph
    }else{
      h = nh
    }
    tn.animate({
      'height': h
    }, 'medium', 'easeInOutQuint', function(){
    }).toggleClass('active');
    
    /*if(tn.hasClass('active')){
      tn.animate({
        'height': ph
      }, 'medium', 'easeInOutQuint').removeClass('active');
    }else{
      if($('.press-infos-extra').not(tn).hasClass('active')){
        $('.press-infos-extra.active').animate({
        'height': ph
        }, 'medium', 'easeInOutQuint', function(){
          $(this).removeClass('active');
          tn.animate({
            'height': nh
          }, 'medium', 'easeInOutQuint').addClass('active');     
        })
      }else{
        tn.animate({
          'height': nh
        }, 'medium', 'easeInOutQuint').addClass('active');        
      }      
    }*/
  });
  
  //Custom Select Dropdowns  
  var x, i, j, l, ll, selElmnt, a, t, c;
  x = document.getElementsByClassName('select-wrapper');
  l = x.length;
  for (i = 0; i < l; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0];
    ll = selElmnt.length;
    /*for each element, create a new DIV that will act as the selected item:*/
    a = document.createElement('DIV'); 
    a.setAttribute('class', 'box');
    a.innerHTML = '<svg><circle cx="50%" cy="50%" r="50%"/></svg><span>' + selElmnt.options[selElmnt.selectedIndex].innerHTML + '</span>';
    x[i].appendChild(a);
    /*for each element, create a new DIV that will contain the option list:*/
    t = document.createElement('DIV');
    t.setAttribute('class', 'select-items hide');
    for (j = 0; j < ll; j++) {
      /*for each option in the original select element,
      create a new DIV that will act as an option item:*/
      c = document.createElement('DIV');
      c.innerHTML = '<svg><circle cx="50%" cy="50%" r="50%"/></svg><span>' + selElmnt.options[j].innerHTML + '</span>';
      c.dataset.value = selElmnt.options[j].dataset.available;
      c.addEventListener('click', function(e){
          var y, i, k, s, h, sl, yl, son;
          s = this.parentNode.parentNode.getElementsByTagName('select')[0];
          sl = s.length;
          son = this.querySelector('span');
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == son.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName('selected');
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute('class');
              }
              this.setAttribute('class', 'selected');
              break;
            }            
          }
          h.click();
      });
      t.appendChild(c);
    }
    x[i].appendChild(t);
    a.addEventListener('click', function(e) {
        /*when the select box is clicked, close any other select boxes,
        and open/close the current select box:*/
        e.stopPropagation();
        closeAllSelect(this);
        this.nextSibling.classList.toggle('hide');
      });
  }
  //Close pop-up options
  function closeAllSelect(elmnt){
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName('select-items');
    y = document.getElementsByClassName('box');
    xl = x.length;
    yl = y.length;
    for (i = 0; i < xl; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('hide');
      }
    }
  }
  
  $(document).click(function(){
    closeAllSelect()
    resetFilters()    
  });
  
  //Lazy Loading
  var L = [].slice.call(document.querySelectorAll('.lazy')),
      P = [].slice.call(document.querySelectorAll('.picture > source'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let t = e.target;
          if(t.tagName == 'IMG'){
            t.src = t.dataset.src;
          	t.classList.remove('lazy');
          }
          if(t.tagName == 'VIDEO'){
            var P = t.play();
            if(P !== undefined){
              P.catch(error => {
                t.controls = true;
                t.classList.add('no-autoplay');
              });
            }
          	t.classList.remove('lazy');
          }
          if(t.parentElement.tagName == 'PICTURE'){
            t.srcset = t.dataset.srcset;
          	t.parentElement.classList.remove('picture');
          }
          o.unobserve(t);
        }
      });
    }, {rootMargin: '100% 0px 0px 0px'});
    L.forEach(function(t){
      o.observe(t);
    });
    P.forEach(function(t){
      o.observe(t);
    });
  }
  
});